import React from "react";
import "./Button.css";

export default function BotonAumentar({ id, onSelect }) {
  return (
    <button
      className="btn-uix btn-aumentar"
      onClick={(e) => {
        e.stopPropagation();
        onSelect(id, "aumentar");
      }}
    >
      +
    </button>
  );
}